import React from 'react'
import { usePopper } from 'react-popper'
import { Row } from './Components'
import { copyToClipboard } from './Utils'

const ClickToCopy = ({ children, copyContent, className = '', style = {} }) => {
  // Popperjs code for the tooltip
  const [showTooltip, setShowTooltip] = React.useState(false)
  const [tooltipBase, setTooltipBase] = React.useState(null)
  const [tooltip, setTooltip] = React.useState(null)
  const [arrowElement, setArrowElement] = React.useState(null)
  const { styles, attributes } = usePopper(tooltipBase, tooltip, {
    placement: 'top',
    modifiers: [{ name: 'arrow', options: { element: arrowElement } }]
  })
  const segementTrackShare = () => {
    window.analytics.track('Copied Share Link')
  }
  //

  React.useEffect(() => {
    if (showTooltip) setTimeout(() => setShowTooltip(false), 1000)
  }, [showTooltip])

  return (
    <Row ref={setTooltipBase} className={className || ''} style={style || {}}>
      <div
        onClick={() => {
          setShowTooltip(true)
          copyToClipboard(copyContent)
          segementTrackShare()
        }}
        onBlur={() => setShowTooltip(false)}
        style={{ height: '100%', width: '100%' }}
        className="cursor-pointer"
      >
        {children}
      </div>

      <div
        style={{
          borderRadius: '10px',
          backgroundColor: '#222222',
          color: 'white',
          padding: '5px 10px 5px 10px',
          marginBottom: '5px',
          opacity: showTooltip ? '100%' : '0%',
          transition: '150ms',
          zIndex: '5',
          fontSize: '12px',
          fontFamily: 'DM Sans',
          ...styles.popper
        }}
        {...attributes.popper}
        ref={setTooltip}
      >
        Copied
        <div ref={setArrowElement} style={styles.arrow} />
      </div>
    </Row>
  )
}

ClickToCopy.defaultProps = {
  className: '',
  style: ''
}

export default ClickToCopy
